import { TranslatePipe } from '../../filters/translate.pipe';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { TableTransactionsComponent } from '../../components/table-transactions/table-transactions.component';
import { ListTabsComponent } from '../../components/list-tabs/list-tabs.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'transactions',
	templateUrl: './transactions.component.html',
	imports: [ CommonModule, PanelDirective, TranslatePipe, ListPagerComponent, TableTransactionsComponent, ListTabsComponent, FormsModule ]
})
export default class TransactionsView implements OnInit {
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('transactions').then(() => {
			this.onResolve();
		});
	};
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.pageSize = 10;
		this.vm.incomePageSize = 10;
		if (this.vm.user.businessUserType === 'SERVICE_PROVIDER' || this.vm.user.businessUserType === 'SERVICE_OWNER') {
			this.vm.tabs = [
				{ label: this.angularFilterHelperService.translate('Wallet.Title.Recent') },
				{ label: this.angularFilterHelperService.translate('Wallet.Title.My_Earnings') }
			]
		}
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
	incomeCurrentPageChanged(newPage) {
		this.vm.incomeCurrentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}